import { HOST, TENANTS_NAMES } from 'tenant/host_config';
// default messages
import defaultMessages_en_GB from '../en-GB.json';
import defaultMessages_es_ES from '../es-ES.json';
// per tenant messages
import xpoMessages_en_GB from './xpo/en-GB.json';

function deepMergeWithSpread(obj1, obj2) {
  const result = { ...obj1 };

  for (let key in obj2) {
    if (obj2.hasOwnProperty(key)) {
      if (obj2[key] instanceof Object && obj1[key] instanceof Object) {
        result[key] = deepMergeWithSpread(obj1[key], obj2[key]);
      } else {
        result[key] = obj2[key];
      }
    }
  }

  return result;
}

const defaultMessages = {
  en_GB: defaultMessages_en_GB,
  es_ES: defaultMessages_es_ES,
};

const messagesByTenant = {
  [TENANTS_NAMES.ontruck]: defaultMessages,
  [TENANTS_NAMES.intraser]: defaultMessages,
  [TENANTS_NAMES.xpo]: {
    en_GB: deepMergeWithSpread(defaultMessages_en_GB, xpoMessages_en_GB),
    es_ES: defaultMessages_es_ES,
  },
  [TENANTS_NAMES.rpt]: defaultMessages,
  [TENANTS_NAMES.acme]: defaultMessages,
};

export const getMessagesByTenant = () => {
  if (!messagesByTenant[HOST]) {
    return defaultMessages;
  }
  return messagesByTenant[HOST];
};
